import { DashboardModule } from '@domain-group/suit-theme'

import useTaskLists from '@hooks/useTaskLists'

import defaultRequestOptions from '@sections/Admin/packs/Projects/defaultRequestOptions'

import TaskListTable from '../TaskListTable'

interface TaskListModuleProps {
  pageFilters: object,
  progressStatus: string,
  title: string,
}

const TaskListModule = (props: TaskListModuleProps) => {
  const { pageFilters, progressStatus, title } = props

  const taskListsPayload = useTaskLists({
    filters: {
      ...pageFilters,
      owner_type: 'Brand',
      progress_status: progressStatus,
      template_project: true,
    },
    performHttpRequests: true,
    requestOptions: {
      ...defaultRequestOptions.taskList,
      include_task_list_task_counts: true,
    },
  })

  const { filteredTaskLists, loading } = taskListsPayload

  return (
    <DashboardModule loading={loading} title={title}>
      <TaskListTable taskLists={filteredTaskLists} />
    </DashboardModule>
  )
}

export default TaskListModule
